import React, { useContext } from 'react';
import { Button, Container } from 'reactstrap';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../../assetss/scss/InstitutionalMembers.scss';
import Slider from 'react-slick';
import { HomeContext } from '../../context';
import { useNavigate } from 'react-router-dom';

const InstitutionalMembers = () => {
    const { instMem } = useContext(HomeContext);
    const navigate = useNavigate();

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: instMem.length > 5 ? 5 : instMem.length,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: false,
        responsive: [
            {
                breakpoint: 992, // medium screens
                settings: {
                    slidesToShow: instMem.length > 4 ? 4 : instMem.length,
                }
            },
            {
                breakpoint: 768, // tablets
                settings: {
                    slidesToShow: instMem.length > 3 ? 3 : instMem.length,
                }
            },
        ]
    };
    const onLinkClick = (link) => {
        if (link) {
            window.open(link, '_blank');
        }
    };
    return (
        <section className="institutional-members">
            <Container className="institutional-content">
                <div className="content">
                    {instMem.length > 0 && (
                        <div className="title">{instMem.length}+ Institutional
                            <span> Members </span>
                            <span className='d-md-block'> <Button className='btn-grad' onClick={() => navigate('/page/institutional-membership')}>Join</Button> </span>
                        </div>
                    )}
                    <div className="logos">
                        <Slider {...settings}>
                            {instMem && instMem.length > 0 && instMem.map((row, index) => {
                                const isWhite = row?.name === 'Creative';
                                return (
                                    <div key={index} className={`logo-item ${isWhite ? 'image-bg' : ''}`} onClick={() => onLinkClick(row?.link)}>
                                        <img src={row.image ? `${process.env.REACT_APP_BASE_URL}download/${row.image}?pathName=members/insti_mem` : 'PlaceholderImage'} alt={row?.name} />
                                    </div>
                                );
                            })}
                        </Slider>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default InstitutionalMembers;
